import React from "react";
import { Box } from "@mui/material";

interface OcTabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
  padding?: string;
  [key: string]: any;
}

export const OcTabPanel = (props: OcTabPanelProps) => {
  const { children, value, index, padding, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          style={{
            padding: padding ? padding : "16px 0px",
          }}
          p={3}
        >
          {children}
        </Box>
      )}
    </div>
  );
};

export default OcTabPanel;
